import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { List, ListItemText } from 'components/ui';
import { SideMenuDrawer, ListMenuItem } from 'components/styles_components/menu';
import { FormattedMessage } from 'react-intl';
import {
  InspectionsLink,
  InspectionSubjectsLink,
  PlacesLink,
  TemplatesLink,
  UsersLink,
  DashboardLink,
  BillingLink,
} from 'utils/link';
import useMobile from 'hooks/use_mobile';

const SideMenu = ({ visible, hideMenu, fullWidth }) => {
  const location = useLocation();
  const isMobile = useMobile();
  const navigate = useNavigate();

  const onItemClick = (link) => {
    if (isMobile) {
      hideMenu();
    }
    navigate(link);
  };

  const linkItems = () => {
    let items = {};
    items[DashboardLink()] = 'navbar.home';
    items[PlacesLink()] = 'navbar.places';
    items[InspectionSubjectsLink()] = 'navbar.inspection_subjects';
    items[InspectionsLink()] = 'navbar.inspections';
    items[TemplatesLink()] = 'navbar.templates';
    items[UsersLink()] = 'navbar.users';
    items[BillingLink()] = 'navbar.billing';
    return items;
  };

  const list = () => {
    let items = linkItems();
    return Object.keys(items).map((link) => {
      return item(link, items[link]);
    });
  };

  const item = (link, translationId, icon = null) => {
    return (
      <ListMenuItem
        key={link}
        onClick={() => onItemClick(link)}
        selected={location.pathname === link || location.pathname.startsWith(`${link}/`)}
      >
        {icon}
        <ListItemText>
          <FormattedMessage id={translationId} />
        </ListItemText>
      </ListMenuItem>
    );
  };

  return (
    <SideMenuDrawer variant="persistent" className={fullWidth ? 'full-width' : ''} open={visible}>
      <List>{list()}</List>
    </SideMenuDrawer>
  );
};

export default SideMenu;
